import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Breadcrumbs, Grid, Link, Typography } from "@mui/material";
import useForm, { Form } from "../../../../hooks/useForm";
import Controls from "../../../../components/form/controls/Controls";
import { checkEqual } from "../../../../utils";
import { Notify } from "../../../../components/notify/Notify";
import { useHistory } from "react-router-dom";
import useCurrentActionCache from "../../../../hooks/useCurrentActionCache";
import { CACHE_ICON } from "../../../../constants/actionCache";
import {
  getFLFIconDetail,
  updateFLFIcon,
  createFLFIcon,
} from "../../../../apis/FLF/icon.api";
import { URL_CDN, path } from "../../../../constants/path";
import { refusedToUpdate } from "../../utils";
import { validationFLFIconInput } from "../../utils/validateInput";
import useQueryConfig from "../../../../hooks/useQueryConfig";

const initialValue = {
  id: "",
  rogoDevSubTypeCode: 0,
  rogoDevSubTypeStr: "",
  deviceName: "",
  iconType: "",
  pathname: "",
};

const iconOption = [
  {
    id: "group_device",
    name: "group_device",
  },
  {
    id: "device",
    name: "device",
  },
  {
    id: "context",
    name: "context",
  },
  {
    id: "vms",
    name: "VMS",
  },
  {
    id: "icon",
    name: "Icon",
  },
];

const showIcon = (file, pathname, iconCode) => {
  if (file) {
    return (
      <img
        style={{ width: "300px", height: "220px" }}
        src={file}
        alt={iconCode}
      />
    );
  }

  if (pathname) {
    return (
      <img
        style={{ width: "300px", height: "220px" }}
        src={`${URL_CDN}/${pathname}`}
        alt={iconCode}
      />
    );
  }

  return "chưa có Icon được chọn";
};

const FLFIconAction = () => {
  // cache
  const { setCurrentActionCache } = useCurrentActionCache();

  let { id } = useParams();
  const history = useHistory();
  const fileInputRef = useRef(null);
  const [listImageIcon, setListImageIcon] = useState([]);
  const [icon, setIcon] = useState([]);
  const [createAnother, setCreateAnother] = useState(false);
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);
  const [file, setFile] = useState();

  let queryConfig = useQueryConfig();

  const { page, limit = 10, iconType } = queryConfig;

  // validation input flf-device
  const validateFLFIconForm = (fieldValues = values) => {
    let temp = validationFLFIconInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFIconForm);

  useEffect(() => {
    if (id) {
      getFLFIconDetail(id, (result) => {
        setValues({ ...result });
        setIcon({ ...result });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!id) {
      // create icon
      if (!file) {
        Notify("warning", "Vui lòng chọn ảnh");
        return;
      }
      if (validateFLFIconForm()) {
        setIsLoadingUpload(true);
        // construct form data
        const formData = new FormData();
        for (let i = 0; i < listImageIcon.length; i++) {
          formData.append("image", listImageIcon[i]);
          formData.append("deviceName", values.deviceName);
          formData.append("iconType", values.iconType);
        }

        // Create icon
        createFLFIcon(formData, (result) => {
          setIsLoadingUpload(false);
          if (result.data?.status === 422) {
            setErrors({ ...result.data.data });
          } else if (result.status === 200) {
            setCurrentActionCache(CACHE_ICON);
            if (createAnother) {
              resetForm();
              setFile(null);
            } else {
              history.push(
                `${path.flfIcon}?iconType=${iconType}&page=${page}&limit=${limit}`
              );
            }
          }
        });
      }
    } else if (id) {
      if (validateFLFIconForm()) {
        const formData = new FormData();
        formData.append("deviceName", values.deviceName);
        formData.append("iconType", values.iconType);

        if (file) {
          for (let i = 0; i < listImageIcon.length; i++) {
            formData.append("image", listImageIcon[i]);
          }
        } else {
          if (checkEqual(icon, values)) {
            return;
          }
        }

        setIsLoadingUpload(true);
        // Upload icon
        updateFLFIcon(id, formData, (result) => {
          if (result.data?.status === 422) {
            setErrors({ ...result.data.data });
          } else {
            setCurrentActionCache(CACHE_ICON);
            history.push(
              `${path.flfIcon}?iconType=${iconType}&page=${page}&limit=${limit}`
            );
          }
          setIsLoadingUpload(false);
        });
      }
    }
  };

  const handleFile = (e) => {
    fileInputRef.current?.setAttribute("value", "");
    setListImageIcon(e.target.files);
    setValues((prev) => {
      return {
        ...prev,
        pathname: "",
      };
    });
    setFile(URL.createObjectURL(e.target.files[0]));
  };

  const handleChangeFile = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      <div className="page-header">
        <h2>{id ? "Edit FLF Icon" : "Add FLF Icon"}</h2>
      </div>
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          underline="hover"
          color="inherit"
          href={`${path.flfIcon}?iconType=${iconType}&page=${page}&limit=${limit}`}
        >
          FLF Icon
        </Link>
        <Typography color="text.primary">
          {id ? "Edit FLF Icon" : "Add FLF Icon"}
        </Typography>
      </Breadcrumbs>
      <Form onSubmit={onSubmit} noValidate>
        <Grid container>
          <Grid item xs={6} p={5}>
            <Controls.Input
              name="deviceName"
              value={values.deviceName}
              label="Device name"
              type="text"
              onChange={handleInputChange}
              error={errors.deviceName}
            />

            <Controls.Select
              name="iconType"
              label="Icon Type"
              value={values.iconType}
              onChange={handleInputChange}
              options={iconOption}
              error={errors.iconType}
            />

            {!id ? (
              <Controls.Checkbox
                name="createAnother"
                label="Create another"
                value={createAnother}
                onChange={() => setCreateAnother(!createAnother)}
              />
            ) : null}

            {/* hidden input */}
            <input
              style={{ display: "none" }}
              type="file"
              accept="image/png"
              className="form-control"
              onChange={handleFile}
              required
              ref={fileInputRef}
              onClick={(event) => {
                event.target.value = null;
              }}
            ></input>

            <Controls.Button
              text="Select icon"
              disabled={isLoadingUpload}
              isLoading={isLoadingUpload}
              sx={{ width: "100%", margin: "10px 0" }}
              onClick={handleChangeFile}
            />
          </Grid>
          <Grid item xs={6} p={5}>
            {showIcon(file, values.pathname, values.rogoDevSubTypeCode)}

            <div style={{ marginTop: "10px" }}>
              <Controls.Button
                disabled={
                  isLoadingUpload ||
                  refusedToUpdate(id, checkEqual(icon, values))
                }
                isLoading={isLoadingUpload}
                type="submit"
                text="Submit"
              />
              {!id ? (
                <Controls.Button
                  disabled={isLoadingUpload}
                  isLoading={isLoadingUpload}
                  text="Reset"
                  color="inherit"
                  onClick={() => {
                    setFile(null);
                    resetForm();
                  }}
                />
              ) : null}
            </div>
          </Grid>
        </Grid>
      </Form>
    </>
  );
};

export default FLFIconAction;
